import logo from "../../images/p2.png"


export default function P2() {
  return (
    <img className="p" src={logo} alt="contact logo" />
   
  );
}